import { detectOS } from '@/utils/utils'

const state = {
  classOption: [], // 班级下拉
  playGuide: false,
  // 获取验证码手机号
  codePhoneObj: {},
  lock: false,
  count: 61,
  bgOrange: true,
  bgGrey: false,
  messages: '',
  isReset: false,
  os: detectOS()
}
// getters
const getters = {
  isWindow: state => {
    return ['Win7', 'Win10', 'WinXP'].includes(state.os)
  },
  count: state => {
    return state.count
  },
  lock: state => {
    return state.lock
  },
  bgOrange: state => {
    return state.bgOrange
  },
  bgGrey: state => {
    return state.bgGrey
  },
  messages: state => {
    return state.messages
  }
}

const actions = {
  // 获取班级下拉列表
  async getClassOption({ commit }) {
    const unit_id = localStorage.getItem('role_id')
    if (unit_id === '40001') {
      const res = await API.get('/edu/zone/channel/agent/class/simple')
      if (res.status < 400) {
        commit('setClassOption', res.data)
      }
    } else {
      const res = await API.get('/edu/zone/classes/simple')
      if (res.status < 400) {
        commit('setClassOption', res.data)
      }
    }
  },
  // 跳转获取code
  async bcmEncode({ commit }, playload) {
    const res = await API.post('/edu/zone/bcm/code/encode', playload)
    return res
  },
  // 登陆type
  async getLoginStatus({ commit }) {
    const jumpParameter = {
      code: localStorage.token,
      pid: 'V-OVJirH'
    }
    await API.post(
      CONFIG.api_backend + '/tiger/accounts/oauth2/authorization',
      jumpParameter,
      [{ noToken: true }]
    )
  }
}

const mutations = {
  setClassOption(state, data) {
    state.classOption = data
  },
  setCodePhone(state, phoneObj) {
    state.codePhoneObj = phoneObj
  },
  getAuthCode(state, timer) {
    // 处理数据的变化
    // 处理倒计时
    if (state.count !== 0) {
      state.count--
      state.lock = true
      state.bgOrange = false
      state.bgGrey = true
      state.messages = '秒后重新发送'
    } else {
      state.bgOrange = true
      state.bgGrey = false
      state.lock = false
      state.count = '重新发送验证码'
      state.messages = ''
      clearInterval(timer)
      state.count = 61
    }
  },
  setResetStatus(state, bool) {
    state.isReset = bool
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
